import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CustomPaginationComponent } from './custom-pagination.component';
import {MatPaginatorModule} from "@angular/material/paginator";

@NgModule({
  declarations: [CustomPaginationComponent],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, MatPaginatorModule],
  exports: [CustomPaginationComponent],
})
export class CustomPaginationModule {}
